import { render } from "./search-overlay.vue?vue&type=template&id=13dd43b8&scoped=true"
import script from "./search-overlay.vue?vue&type=script&lang=js"
export * from "./search-overlay.vue?vue&type=script&lang=js"

import "./search-overlay.vue?vue&type=style&index=0&id=13dd43b8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13dd43b8"]])

export default __exports__